/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unauthorizederror1Inputs */

const en_unauthorizederror1 = /** @type {(inputs: Unauthorizederror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are not authorized to perform this action.`)
};

const de_unauthorizederror1 = /** @type {(inputs: Unauthorizederror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das darfst du nicht.`)
};

/**
* | output |
* | --- |
* | "You are not authorized to perform this action." |
*
* @param {Unauthorizederror1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unauthorizederror1 = /** @type {((inputs?: Unauthorizederror1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unauthorizederror1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unauthorizederror1(inputs)
	return de_unauthorizederror1(inputs)
});
export { unauthorizederror1 as "unauthorizedError" }